<template>
	<div class="app-container">
		<el-row class="navigation">
			<el-col align="left">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item :to="{ path: '' }">当前位置:</el-breadcrumb-item>
					<el-breadcrumb-item :to="{ path: '/main/index' }">首页</el-breadcrumb-item>
<!--					<el-breadcrumb-item :to="{ path: '' }">质量提升综合服务</el-breadcrumb-item>-->
					<el-breadcrumb-item :to="{ path: '/main/zltszhfw/pxfw' }">海外信息发布</el-breadcrumb-item>
					<el-breadcrumb-item>详情</el-breadcrumb-item>
				</el-breadcrumb>
			</el-col>
		</el-row>

		<el-row class="content">
			<h1  style="font-family: 微软雅黑, 宋体">{{detail.pxggTitle}}</h1>
			<el-row class="soure">
				<el-col :span="8">发布时间：{{ parseTime(detail.pxggFbtime, '{y}-{m}-{d}') }}</el-col>
				<el-col :span="8">访问量：{{browseCount}}</el-col>
				<el-col :span="8">来源：威海市市场监督管理局</el-col>
			</el-row>
			<!-- 在下面添加了table的css，以后富文本插件完善了再把table的css删除 -->
			<div v-html="detail.pxggContent" class="eidt-content"></div>
			<div class="ewmp" v-if="isShowTrain">
				<div>
					<div id="qrcodeBM" class="ewm"></div>
					<span>报名二维码</span>
				</div>
				<div>
					<div id="qrcodeQD" class="ewm"></div>
					<span>签到二维码</span>
				</div>
			</div>
			<div class="files" v-if="detail.sysAttachments.length>0">
				<div style="color: #4A8DEC;font-weight: 600;margin-top: 2rem;">
					附件下载：
				</div>
				<div class="file" v-for="(item,index) in detail.sysAttachments" :key="index" @click="handleDownload(item)"> 
					{{index+1}} 、{{item.fileName}}
				</div>
			</div>
			
		</el-row>
	</div>
</template>

<script>
	import {
		getBrowseCount
	} from "@/api/basedata/records";
	import QRCode from 'qrcodejs2';
	export default {
		name: "detail",
		data() {
			return {
				// 遮罩层
				loading: true,
				recid: undefined,
				type: undefined,
				detail: {},
				browseCount: 0,
				isTrain:'N',
				isShowTrain:false,
				ywViews:{
					busRecid:undefined,
					busTableName:'yw_ycjygypx_pxgg',
				},
			}
		},
		created() {
			this.detail = JSON.parse(localStorage.getItem('pxfwDetail'));
			console.log(this.detail);
			this.recid = this.detail.recid;
			this.isTrain = this.detail.isTrain;
			this.getBrowseData();
			if(this.isTrain != undefined && this.isTrain !='' && this.isTrain==='Y'){
				this.qrCode();
				this.isShowTrain = true;
			}
		},
		methods: {
			toPage(url) {
				this.$router.push({
					path: url,
				});
				this.$store.commit('SET_MAININDEX', url);
			},
			getBrowseData() {
				this.ywViews.busRecid= this.recid;
				getBrowseCount(this.ywViews).then(response => {
					this.browseCount = response;
				})
			},
			qrCode() {
				var whereJson={
					recid:this.detail.recid,
				}
				var whereStr=JSON.stringify(whereJson);
				console.log(whereStr)
			  this.$nextTick(function () {
			      document.getElementById("qrcodeBM").innerHTML = "";
			      let qrcode = new QRCode("qrcodeBM", {
			          width: 100,
			          height: 100,
			          text: this.Config.loginJumpUrl+"/mobile/sign_up.html?wherestr="+whereStr,//"http://fvxqk2.natappfree.cc/mobile/sign_up.html?wherestr="+whereStr,
			          colorDark: "#000000",
			          colorLight: "#ffffff"
			      });
			  });
			  this.$nextTick(function () {
			      document.getElementById("qrcodeQD").innerHTML = "";
			      let qrcode = new QRCode("qrcodeQD", {
			          width: 100,
			          height: 100,
			          text: this.Config.loginJumpUrl+"/mobile/sign_in.html?wherestr="+whereStr,//"http://fvxqk2.natappfree.cc/mobile/sign_in.html?wherestr="+whereStr,
			          colorDark: "#000000",
			          colorLight: "#ffffff"
			      });
			  });
			},
		}
	}
</script>

<style scoped>
	.app-container {
		padding: 0px 15px 20px;
		background-color: #ffffff;
	}

	.navigation {
		padding: 20px 15px;
		line-height: 20px;
		height: 60px;
		background-color: #F5F5F5;
		margin-bottom: 15px;
	}

	.content {
		border: 1px solid #cccccc;
		padding: 20px 80px;
	}

	.soure {
		background-color: #f3f3f3;
		padding: 10px;
		margin: 25px 0;
	}
	.eidt-content{
		text-align: left;
	}
	/* table 样式 */
	/deep/ table {
	  border-top: 1px solid #ccc;
	  border-left: 1px solid #ccc;
	}
	/deep/ table td,
	/deep/ table th {
	  border-bottom: 1px solid #ccc;
	  border-right: 1px solid #ccc;
	  padding: 3px 5px;
	}
	/deep/ table th {
	  border-bottom: 2px solid #ccc;
	  text-align: center;
	}
	.files{
		text-align: left;
	}
	.file{
		cursor: pointer;
		margin-top: 1rem;
	}
	.file:hover{
		color: #409EFF;
	}
	.ewmp{
		margin-top: 1.25rem;
		display: flex;
		align-items: center;
		justify-content: space-evenly;
	}
	.ewm{
		margin-bottom: 0.625rem;
	}
	.ewmp span{
		font-size: 1rem;
	}
</style>
